module.exports = __webpack_public_path__ + "static/media/video-advmindfulness-threats-en.eb0c549f.vtt";